import $ from 'jquery';

$ajaxButtons = $('.js-ajax-button');
if($ajaxButtons.length > 0) {
    $(document.body).on('click', '.js-ajax-button', function() {
        const $this = $(this);
        const data = $this.data();
        $.ajax({
            url: data.url,
        }).done(function(result){
            if(data.classOnSuccess !== undefined)
                $this.addClass(data.classOnSuccess);
            if(data.containerOnSuccess !== undefined)
                $(data.containerOnSuccess)[0].outerHTML = result;
        });
    });
}